<script setup lang="ts">
import LoginStepWrapper from '../LoginStepWrapper.vue';
import { AuthStep } from '@store/auth';
const { tokenDisabled } = defineProps<{
    tokenDisabled?: boolean;
}>();

const emit = defineEmits<{
    submit: [step: AuthStep];
    back: [];
}>();

const authStore = useAuthStore();
const { loading, error } = classToRefs(authStore);
const isSubmit = ref(true);

const mobileOrEmail = defineModel<string>('username', { default: '' });

function forgotPassword() {
    const username = authStore.validateUsername(mobileOrEmail.value);
    if (!username) {
        return;
    }
    emit('submit', AuthStep.ChangePasswordToken);
}
</script>

<template>
    <LoginStepWrapper
        title="فراموشی رمز عبور"
        sub-title="  جهت بازیابی رمز عبور، شماره موبایل خود را وارد کنید."
        @submit="forgotPassword"
    >
        <template #inputs="{ focus }">
            <mr-input
                v-model="mobileOrEmail"
                input-id="phonenumber"
                type="text"
                placeholder="شماره موبایل"
                dir="ltr"
                :error-text="error.MobileOrEmail || ''"
                :hide-description="!error.MobileOrEmail"
                :invalid="!!error.MobileOrEmail"
                required
                name="username"
                autofocus
                @focus="focus"
            />
        </template>
        <template #actions>
            <mr-button
                full-width
                :loading="isSubmit && loading"
                type="submit"
                :disabled="tokenDisabled"
            >
                بازیابی رمز عبور
            </mr-button>
        </template>
    </LoginStepWrapper>
</template>

<style scoped lang="scss"></style>
